import { render, staticRenderFns } from "./NewTaskDialog.vue?vue&type=template&id=33ebd3dd&scoped=true&"
import script from "./NewTaskDialog.vue?vue&type=script&lang=js&"
export * from "./NewTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewTaskDialog.vue?vue&type=style&index=0&id=33ebd3dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ebd3dd",
  null
  
)

export default component.exports